import { createFileRoute } from '@tanstack/react-router';

import { Show } from '@/modules/Projects/Show';

export const Route = createFileRoute('/app/projects/$projectId/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
    ...(search.view === 'list' || search.view === 'planning' ? { view: search.view } : {}),
    ...(search.planningView === 'on' || search.planningView === 'off'
      ? { planningView: search.planningView }
      : {}),
  }),
});

function RouteComponent() {
  const { projectId } = Route.useParams();

  return <Show projectId={projectId} assignmentId={undefined} />;
}
